import React from 'react';
import { ArrowRight, Loader2 } from 'lucide-react';
import { LoginSubmit } from './LoginControls';

/**
 * `/auth/action` screens shared by every link mode: working on the link, done
 * (password updated or email confirmed), the link can no longer be used, or
 * the link could not be checked. The heading and body come from the card.
 */

/** While a link is checked or confirmed, or while a confirmed link signs the person in. */
export const ActionLinkWorking: React.FC<{ label: string }> = ({ label }) => (
  <div role="status" aria-label={label} className="flex justify-center py-s3 text-ink-muted">
    <Loader2 className="h-[20px] w-[20px] animate-spin" />
  </div>
);

const OneButton: React.FC<{ onClick: () => void; icon?: React.ReactNode; children: React.ReactNode }> = ({
  onClick,
  icon,
  children,
}) => (
  <form
    onSubmit={(e) => {
      e.preventDefault();
      onClick();
    }}
    className="flex flex-col"
  >
    <LoginSubmit icon={icon}>{children}</LoginSubmit>
  </form>
);

/** "Password updated" / "Email confirmed" → sign-in with the address filled in. */
export const ActionDoneStep: React.FC<{ onSignIn: () => void }> = ({ onSignIn }) => (
  <OneButton onClick={onSignIn} icon={<ArrowRight className="h-[15px] w-[15px]" />}>
    Go to sign in
  </OneButton>
);

/** Expired, already used, unknown mode or missing code. */
export const ActionLinkInvalidStep: React.FC<{ onBack: () => void }> = ({ onBack }) => (
  <OneButton onClick={onBack}>Back to sign in</OneButton>
);

/** The code could not be checked (network), which says nothing about the link. */
export const ActionLinkRetryStep: React.FC<{ onRetry: () => void }> = ({ onRetry }) => (
  <OneButton onClick={onRetry}>Try again</OneButton>
);
